import { createQueryKeys } from '@lukemorales/query-key-factory';

import {
    getSupplierGroupSettings,
    getSupplierGroups as getSupplierGroupsList,
    GetSupplierGroupsParams as GetSupplierGroupsListParams,
} from '../clients/company.api';
import { getSurcharges } from '../clients/gateway.api';
import {
    GetSupplierGroupsParams,
    getSpotAvailability,
    getSupplierGroup,
    getSupplierGroups,
} from '../clients/supplierGroups.api';

export const supplierGroups = createQueryKeys('supplierGroups', {
    detail: (groupId: string) => ({
        queryKey: [groupId],
        queryFn: () => getSupplierGroup(groupId),
        contextQueries: {
            surcharges: {
                queryKey: null,
                queryFn: () => getSurcharges(groupId),
            },
            settings: {
                queryKey: null,
                queryFn: () => getSupplierGroupSettings(groupId),
            },
        },
    }),
    spotAvailability: (portCountryCode: string, testOrder: boolean) => ({
        queryKey: [{ portCountryCode, testOrder }],
        queryFn: () => getSpotAvailability(portCountryCode, testOrder),
    }),
    pagination: (params: GetSupplierGroupsParams) => ({
        queryKey: [{ params }],
        queryFn: () => getSupplierGroups(params),
    }),
    list: (params: GetSupplierGroupsListParams = {}) => ({
        queryKey: [{ params }],
        queryFn: () => getSupplierGroupsList(params),
    }),
    comboBoxOptions: (params: GetSupplierGroupsListParams) => ({
        queryKey: [{ params }],
    }),
    selectedComboBoxOption: (supplierGroupId: string) => ({
        queryKey: [supplierGroupId],
    }),
    paginatedComboBoxOptions: (params: GetSupplierGroupsParams) => ({
        queryKey: [{ params }],
    }),
    selectedComboBoxOptions: (supplierGroupIds: string[], spotAllowed?: boolean) => ({
        queryKey: [{ supplierGroupIds, spotAllowed }],
    }),
});
